
import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from '../services/app-config.service';

@Pipe({
  name: 'image',
})
export class ImagePipe implements PipeTransform {
  constructor(private appConfig: AppConfigService) {}

  transform(imgURL: string = null, param: string = 'sinoptic'): any {
    let url = '';
    // console.log(direction);
    if (imgURL === '' || imgURL == null || imgURL === 'NoImage') {
      if (param === 'in') {
        url = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/lane-images/noImage.png`;
      } else if (param === 'out') {
        url = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/lane-images/noImage.png`;
      } else if (param === 'sinoptic') {
        url = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/lane-images/basculaNoCamara/C.png`;
      } else {
        url = `${this.appConfig.getConfig().installationNameFolder}access-manager/assets/lane-images/imgFront.png`;
      }
    } else {
      if (param === 'in' || param === 'out') {
        url = `${this.appConfig.getConfig().serverURL}/images/?path=${imgURL}`;
      } else {
        url = imgURL;
      }
    }
    console.log('++++++++++++++++++' + url);
    return url;
  }
}
